import { SortingOptionsType } from '@components/design/migrated/Table';
import { SortDirection, SortingOptions } from '@components/design/migrated/Table/Sorting/types';
import { useCallback } from 'react';
import { usePageConfig } from '@utils/pageConfig/PagesConfigContext';
import { PageType } from '@utils/pageConfig/Types';

interface PersistedSortingArgs {
  tableId: string;
  defaultSorting: SortingOptionsType;
}

export interface PersistedSorting {
  sorting: SortingOptionsType;
  updateOptions: (options: SortingOptionsType) => void;
}

export enum SortDirectionLabel {
  ASC = 'Ascending',
  DESC = 'Descending',
}

export const SortDirectionMapping: Record<SortDirection, SortDirectionLabel> = {
  [SortDirection.asc]: SortDirectionLabel.ASC,
  [SortDirection.desc]: SortDirectionLabel.DESC,
};

export const matchKPI = (headerKeyToSearch: SortingOptionsType, kpiDropdownOptions: any) => {
  return kpiDropdownOptions.find((e: { headerKey: any }) => e.headerKey === headerKeyToSearch.headerKey);
};

export const getSortingOptions = ({ tableId, defaultSorting }: PersistedSortingArgs, sortingOptions: any) => {
  if (Object.keys(sortingOptions).length === 0) {
    return defaultSorting;
  }
  return sortingOptions;
};

export const setSortingOptionMethod = (options: SortingOptions, setSortingOptions: any) => {
  setSortingOptions(options);
};

export const usePersistedSorting = ({ tableId, defaultSorting }: PersistedSortingArgs): PersistedSorting => {
  const pagesConfig = usePageConfig();
  let sortingOptions = pagesConfig.sortingOptions;
  let setSortingOptions = pagesConfig.setSortingOptions;
  if (pagesConfig.pageType === PageType.RI_PRODUCT) {
    sortingOptions = pagesConfig.sortingOptionsProducts;
    setSortingOptions = pagesConfig.setSortingOptionsProducts;
  }

  const sorting: SortingOptionsType = getSortingOptions({ tableId, defaultSorting }, sortingOptions);

  const updateOptions = useCallback(
    (options: SortingOptionsType) => {
      setSortingOptionMethod(options, setSortingOptions);
    },
    [setSortingOptions],
  );

  return { sorting, updateOptions };
};

export default usePersistedSorting;
